/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetProfilePhotoRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/set_profile_photo_client.pb'
import {SetProfilePhotoResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/set_profile_photo_client.pb'


export const setProfilePhotoApp = (request: SetProfilePhotoRequest, options?: CashRequestOptions) => post<SetProfilePhotoRequest, SetProfilePhotoResponse>("/2.0/cash/set-profile-photo-app", request, {...options, rejectOnError: true })